import {
    TransportCapacityOrder,
    TransportCapacityOrderConfirmation,
    TransportOrder,
    TransportOrderBundle,
    TransportOrderConfirmation,
} from '../transportAssignment.types';
import { ConfirmationFormParams } from './TransportAssignmentConfirmationForm';
import { getNonFinalizedAndNonCancelledOrders } from '../TransportAssignmentUtils';

const getOrderIds = (assignment: TransportOrder | TransportOrderBundle) =>
    getNonFinalizedAndNonCancelledOrders(assignment).map((order) =>
        'transportOrderId' in order ? order.transportOrderId : order.id,
    );

const getVehicleIds = (assignment: TransportOrder | TransportOrderBundle) =>
    getNonFinalizedAndNonCancelledOrders(assignment).flatMap((order) => order.vehicle.id);

export const getCapacityConfirmationPayload = (
    capacityOrder: TransportCapacityOrder,
    { newConfirmedPickUpDate, newConfirmedDeliveryDate, newMeansOfTransport }: ConfirmationFormParams,
): { transportCapacityOrderId: string; confirmation: TransportCapacityOrderConfirmation } => ({
    transportCapacityOrderId: capacityOrder.transportCapacityOrderId,
    confirmation: {
        pickUpAt: newConfirmedPickUpDate,
        deliverAt: newConfirmedDeliveryDate,
        meansOfTransportId: newMeansOfTransport?.id,
        trailerId: newMeansOfTransport?.trailerId,
    },
});

export const getTransportOrderConfirmationPayload = (
    transportAssignment: TransportOrder | TransportOrderBundle,
    {
        newConfirmedPickUpDate,
        newConfirmedDeliveryDate,
        newMeansOfTransport,
        newUnloadingAddress,
    }: ConfirmationFormParams,
): { confirmation: TransportOrderConfirmation } => ({
    confirmation: {
        transportOrderIds: getOrderIds(transportAssignment),
        vehicleIds: getVehicleIds(transportAssignment),
        pickUpAt: newConfirmedPickUpDate,
        deliverAt: newConfirmedDeliveryDate,
        meansOfTransportId: newMeansOfTransport?.id,
        meansOfTransportAssetId: newMeansOfTransport?.assetId,
        trailerId: newMeansOfTransport?.trailerId,
        unloadingAddressId: newUnloadingAddress?.identifier,
    },
});

export const getBulkTransportOrderConfirmationPayload = (
    transportAssignments: TransportOrder[],
    { newConfirmedPickUpDate, newConfirmedDeliveryDate, newMeansOfTransport }: ConfirmationFormParams,
): { confirmation: TransportOrderConfirmation } => ({
    confirmation: {
        transportOrderIds: transportAssignments.map((assignment) => assignment.transportOrderId),
        vehicleIds: transportAssignments.map((assignment) => assignment.vehicle.id),
        pickUpAt: newConfirmedPickUpDate,
        deliverAt: newConfirmedDeliveryDate,
        meansOfTransportId: newMeansOfTransport?.id,
        meansOfTransportAssetId: undefined,
        trailerId: newMeansOfTransport?.trailerId,
    },
});
